import { languageToLocale } from '@becurious/languagetolocale';
import applyTracking from '@becurious/applytracking';

export default class BookingEngine {
	/**
	 * Constructor
	 *
	 * @param {Object} config Configuration options
	 */
	constructor ({ hotelID }) {
		this.baseUrl = `https://direct-book.com/properties/${hotelID}`;
		this.language = 'en';
		this.config = {
			hotelID
		};
	}

	/**
	 * Convert a string representation of a date to a date object
	 *
	 * @param {*} date Date as an object or string
	 * @returns {String} Date as a string
	 */
	dateToString (date) {
		if (typeof date === 'string') {
			return date;
		}

		return date.getFullYear()
			+ '-'
			+ ('0' + (date.getMonth() + 1)).slice(-2)
			+ '-'
			+ ('0' + date.getDate()).slice(-2);
	}

	/**
	 * Open the booking engine
	 *
	 * @param {object} options  Options object
	 *
	 * @return {void}
	 */
	getUrl (options) {
		const url = new URL(this.baseUrl);
		url.search = (new URL(document.location)).searchParams;

		if (!options.language) {
			options.language = this.language;
		}

		if (options.language) {
			url.searchParams.append('locale', options.language);
		}

		if (options.arrival) {
			url.searchParams.append('checkInDate', this.dateToString(options.arrival));
		}

		if (options.departure) {
			url.searchParams.append('checkOutDate', this.dateToString(options.departure));
		}

		if (options.pax) {
			url.searchParams.append('[adult]', options.pax);
		}

		if (options.roomid) {
			url.searchParams.append('room_type', options.roomid);
		}

		return applyTracking(url.href);
	}
}
